import { render, staticRenderFns } from "./MpDnDFreeV2.vue?vue&type=template&id=bc2d1eee&scoped=true&"
import script from "./MpDnDFreeV2.vue?vue&type=script&lang=js&"
export * from "./MpDnDFreeV2.vue?vue&type=script&lang=js&"
import style1 from "./MpDnDFreeV2.vue?vue&type=style&index=1&id=bc2d1eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2d1eee",
  null
  
)

export default component.exports